/* eslint-disable  */
import { Component } from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import PageTitle from '../../../common/page-title';
import {connect} from 'react-redux';
import BackLink from '../../../common/back-link';
import {getSmsLog} from '../../../../actions/logs';

const ViewEntry = ({label, data}) => (
  <Row>
    <Col lg={4} className="text-bold">
      {label}:
    </Col>
    <Col lg={8}>
      {data}
    </Col>
  </Row>
);

class SmsView extends Component {
  constructor(props) {
    super(props);
    this.id = this.props.match.params.id;
  }
  
  componentDidMount() {
    const {dispatch} = this.props;
    dispatch(getSmsLog(this.id));
  }
  
  render() {
    const {response, mobile, body, 'user-id': userID} = this.props.sms.attributes;
    return (
      <Container fluid className="notifications">
        <BackLink href="/admin/sms-logs"/>
        <PageTitle>Sms notification log</PageTitle>
        <ViewEntry label="Recipient" data={mobile}/>
        <ViewEntry label="Message" data={body}/>
        <ViewEntry label="User ID" data={userID}/>
        <ViewEntry label="Response" data={response}/>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  sms: state.notificationLog.sms,
  loading: state.notificationLog.fetching && !state.notificationLog.fetched,
});

export default connect(mapStateToProps)(SmsView);
